import Vue from "vue"
import Decimal from "decimal.js"

import { getGoldBalance } from "../../api/gold-balance"

const state = () => ({
	goldBalanceNew: [],
	apiStatus: 'idle', // 'idle' | 'loading' | 'success' | 'error',

	showHolding: JSON.parse(localStorage.getItem('showHolding')) == null ? true : JSON.parse(localStorage.getItem('showHolding')),
})

const getters = {
	getGoldBalanceNew(state) {
		return state.goldBalanceNew
	},

	getGoldBalanceByNewContractId: (state) => (contractId) => {
		if (state.goldBalanceNew) {
			return state.goldBalanceNew.find(item => item.contract_id == contractId)
		}

		return null
	},

	// Amount of gold in that is currently in process of withdrawal in Gram
	getGoldWithdrawalProcess: (state) => (contractId) => {
		if (state.goldBalanceNew) {
			return state.goldBalanceNew.find(item => item.contract_id == contractId).withdrawal_process
		}

		return null
	},

	// Amount of gold in main (TRADE) pocket in Gram
	getTradeGoldByContractId: (state, getters) => (contractId) => {
		const goldBalance = getters.getGoldBalanceByNewContractId(contractId)
		const tradeGoldBalance = goldBalance ? goldBalance.pockets.find(pocket => pocket.type.toLowerCase() === 'trade') : null
		return tradeGoldBalance ? tradeGoldBalance.remaining_quantity : 0
	},

	// Amount of gold in main (TRADE) pocket that is currently in process of selling in Gram
	getInProcessSellTradeGoldByContractId: (state, getters) => (contractId) => {
		const goldBalance = getters.getGoldBalanceByNewContractId(contractId)
		const tradeGoldBalance = goldBalance ? goldBalance.pockets.find(pocket => pocket.type.toLowerCase() === 'trade') : null
		return tradeGoldBalance ? tradeGoldBalance.sell_process : 0
	},

	// Amount of gold in main (TRADE) pocket that is currently in process of buying in Gram
	getInProcessBuyTradeGoldByContractId: (state, getters) => (contractId) => {
		const goldBalance = getters.getGoldBalanceByNewContractId(contractId)
		const tradeGoldBalance = goldBalance ? goldBalance.pockets.find(pocket => pocket.type.toLowerCase() === 'trade') : null
		return tradeGoldBalance ? tradeGoldBalance.buy_process : 0
	},

	// Amount of gold in main (TRADE) pocket available for selling (excluding sell_process and withdrawal_process) in Gram
	getAvailableTradeGoldByContractId: (state, getters) => (contractId) => {
		const goldBalance = getters.getGoldBalanceByNewContractId(contractId)
		const tradeGoldBalance = goldBalance ? goldBalance.pockets.find(pocket => pocket.type.toLowerCase() === 'trade') : null

		return tradeGoldBalance ? Decimal.sub(tradeGoldBalance.remaining_quantity, tradeGoldBalance.sell_process).minus(tradeGoldBalance.withdrawal_process) : 0
	},

	// Amount of gold in main (TRADE) pocket available for selling (excluding sell_process and withdrawal_process) in Quantity
	getAvailableTradeGoldQuantityByContractId: (state, getters, rootState, rootGetters) => (contractId) => {
		const contractConfigs = rootGetters.getContractConfigs(contractId)
		const availableTradeGold = getters.getAvailableTradeGoldByContractId(contractId)

		const availableQuantity = Decimal.div(availableTradeGold, contractConfigs.weightInGram).toFixed()
		return availableQuantity
	}
}

const actions = {
	async fetchGoldBalance({ commit, rootState }, params) {
		commit('setApiStatus', 'loading')

		try {
			const response = await getGoldBalance(params)

			// only use contract that used in the app.
			// so, only get contract that exist in rootState.holdingsSequence
			const goldBalance = response.data.map(item => {
				const existsInHoldings = rootState.holdingsSequence.find(contract_id => contract_id == item.contract_id)
				if (existsInHoldings) {
					return item
				}
			}).filter(item => item !== undefined)

			goldBalance.forEach(item => {
				// if pocket type trade not exist, create it at the beginning of the pockets array
				// it because pocket trade always exist even if the user never buy gold
				if (!item.pockets.find(pocket => pocket.type.toLowerCase() === 'trade')) {
					item.pockets.unshift({
						contract_id: item.contract_id,
						quantity: 0,
						remaining_cost_idr: 0,
						remaining_cost_usd: 0,
						remaining_quantity: 0,
						remaining_units: 0,
						sell_process: 0,
						buy_process: 0,
						sold_amount_idr: 0,
						sold_amount_usd: 0,
						sold_cost_idr: 0,
						sold_cost_usd: 0,
						sold_quantity: 0,
						type: 'TRADE',
					})
				}
			})

			commit('setGoldBalanceNew_mut', goldBalance)
			commit('setApiStatus', 'success')
		} catch (error) {
			commit('setApiStatus', 'error')

			console.error('Error fetching gold balance:', error)
		}
	},
}

const mutations = {
	setGoldBalanceNew_mut(state, payload) {
		state.goldBalanceNew = payload
	},

	setApiStatus(state, status) {
		state.apiStatus = status
	},

	setShowHolding(state, value) {
		state.showHolding = value
		localStorage.setItem('showHolding', JSON.stringify(value))
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}